<div class="container" cdkFocusInitial aria-modal="true">
    <div mat-dialog-title class="dialog-title">
        <h1>Request Interregional Support</h1>
        <button mat-icon-button aria-label="close dialog" mat-dialog-close aria-label="Close">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content>
        <div class="div-label-block">
            <h2>FIRE DETAILS</h2>
            <mat-label class="title">Fire/Complex name</mat-label>
            <mat-label>{{data.fireRecord.baer_name}}</mat-label>
            <mat-label class="title">Forest name</mat-label>
            <mat-label>{{data.fireRecord.forest_name | forest_filter}}</mat-label>
            <mat-label class="title">Region</mat-label>
            <mat-label>{{data.fireRecord.region}}</mat-label>
            <mat-label class="title">Complexity</mat-label>
            <mat-label class="chip-label" [ngSwitch]="data.fireRecord.fire_complexity_id">
                <mat-chip *ngSwitchCase=1 class="chip-low">LOW</mat-chip>
                <mat-chip *ngSwitchCase=2 class="chip-moderate">MODERATE</mat-chip>
                <mat-chip *ngSwitchCase=0 class="chip-high">HIGH</mat-chip>
                <div *ngSwitchDefault>--</div>
            </mat-label>
            <mat-label class="title">Assessment Status</mat-label>
            <mat-label class="chip-label" [ngSwitch]="data.fireRecord.assessment_status_id">
                <mat-chip [ngClass]="'chip-'+data.fireRecord.assessment_status_id">
                    {{data.fireRecord.assessment_status_id | statusBadge}}
                </mat-chip>
            </mat-label>
            <mat-label class="title"></mat-label>
            <mat-label></mat-label>
        </div>
        <div class="support-warning" *ngIf="existingTeamRequest || existingLeadRequest">
            <fa-icon [icon]="faWarning" class="faWarning" aria-label="Warning"></fa-icon>
            <div class="support-text">
                <span class="support-title">
                    Request Already Submitted
                </span>
                <br>
                <span class="support-description">
                    An interregional support request has been made already. Make any edits below to update the request.
                </span>
            </div>
        </div>
        <form id="filter_form" class="filter_form" [formGroup]="leadForm">
            <div class="whole-line">
                <div class="title">Do you need a Team Leader?</div>
                <mat-radio-group required (change)="checkExistingReport()" formControlName="team_leader"
                    class="radio-buttons">
                    <mat-radio-button [value]="true" color="primary" class="radio-button">Yes</mat-radio-button>
                    <br>
                    <mat-radio-button [value]="false" color="primary">No</mat-radio-button>
                </mat-radio-group>
                <div class="whole-line" *ngIf="leadForm.value.team_leader">
                    <div class="title">Additional Details<span class="gray-text">(Optional)</span>
                    </div>
                    <mat-form-field class="text-area" appearance="outline">
                        <textarea matInput formControlName="additional_details" placeholder="Enter description"></textarea>
                    </mat-form-field>
                </div>
            </div>
        </form>
        <form id="filter_form" class="filter_form" [formGroup]="teamForm">
            <div class="whole-line">
                @if (assessment) {

                <div class="title">Do you need to request Shortage Team Members?
                    <mat-icon matTooltip="These are known positions of low availability within a region that will be needed on this assessment team."
                        matTooltipClass="tooltipClass"
                        class="info-blue fa-regular fa-circle-info">info_outline</mat-icon>
                </div>
                } @else {

                <div class="title">Do you need Team Members with specific skills?</div>
                }
                <mat-radio-group (change)="checkExistingReport()" formControlName="team_members"
                    class="radio-buttons">
                    <mat-radio-button [value]="true" color="primary" class="radio-button">Yes</mat-radio-button>
                    <br>
                    <mat-radio-button [value]="false" color="primary">No</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="whole-line" *ngIf="teamForm.value.team_members">
                @if (assessment) {
                <div class="title"><span class="red">*</span>Select shortage skills needed on this assessment:<span
                        class="gray-text">(Select all that apply)</span></div>
                } @else {
                <div class="title"><span class="red">*</span>Select skill(s) needed on this report:<span
                        class="gray-text">(Select all that apply)</span></div>
                }
                <div class="whole-line checkBoxGroup">
                    <div *ngFor="let skill of skillList">
                        <mat-checkbox (change)="updateSkill(skill)" [checked]="skill.checked">
                            {{ skill.name | skills }}
                        </mat-checkbox>
                    </div>
                </div>
            </div>
            <div class="whole-line" *ngIf="teamForm.value.team_members">
                <div class="title">Additional Details<span class="gray-text">(Optional)</span>
                </div>
                <mat-form-field class="text-area" appearance="outline">
                    <textarea matInput formControlName="additional_details" placeholder="Enter description"></textarea>
                </mat-form-field>
            </div>
        </form>
    </mat-dialog-content>
    <div mat-dialog-actions>
        <div class="button-row">
            <button aria-label="Cancel" class="usa-button usa-button--secondary" mat-dialog-close>Cancel</button>
            <button aria-label="Update" class="usa-button" [disabled]="!teamForm.valid || !formValid"
                (click)="submitRequest()">Submit Request<i class="material-icons">chevron_right</i></button>
        </div>
    </div>
</div>
